import { Box, styled } from "@mui/material";

const DiagonalButtonWrapper = styled(Box)({
  position: 'relative',
  display: 'inline-flex',
  overflow: 'hidden',

});
export default DiagonalButtonWrapper;
